export const homeObjOne = {
  id: "Sobrenosotros",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topline: "CPJ",
  headline: "Sobre Nosotros",
  description:
    "Somos una empresa familiar con muchos años de experiencia en el mercado. Nos esforzamos por ofrecer una amplia selección de productos de ferretería y herramientas de construcción de alta calidad a precios razonables. Además, ofrecemos un servicio excepcional y personalizado a todos nuestros clientes. Nos enorgullece ser una empresa confiable y accesible para los profesionales y entusiastas de la construcción. Nos apasiona ayudar a nuestros clientes a lograr sus proyectos con éxito. ¡Visitenos hoy para experimentar la diferencia!",
  imgStart: false,
  img: require("../../images/sobreNosotros.png"),
  alt: "logo de cpj",
  dark: true,
  primary: true,
  darkText: false,
};
